import { ListItemButton as MUIListItemButton, ListItemButtonProps as MUIListItemButtonProps } from '@mui/material';

export type ListItemButtonProps<C extends React.ElementType = React.ElementType> = MUIListItemButtonProps<C, { component?: C }>;

export const ListItemButton = MUIListItemButton;
